<template>
    <div class="camera-control-widget-container">
        <PhotoVideoSwitchWidget/>
        <CameraCaptureWidget/>
    </div>
</template>

<script>
  import PhotoVideoSwitchWidget from "./PhotoVideoSwitchWidget";
  import CameraCaptureWidget from "./CameraCaptureWidget";
  export default {
    name: "CameraControlsWidget",
    components: {CameraCaptureWidget, PhotoVideoSwitchWidget}
  }
</script>

<style scoped>
    .camera-control-widget-container {
        background-color: black;
        display: flex;
        flex-direction: column;
    }

</style>
